export const COMMUNITY_CREATE = 'COMMUNITY_CREATE';
export const COMMUNITY_CREATE_RESULT = 'COMMUNITY_CREATE_RESULT';
export const COMMUNITY_CREATE_RESET = 'COMMUNITY_CREATE_RESET';
export const COMMUNITY_UPDATE = 'COMMUNITY_UPDATE';
export const COMMUNITY_UPDATE_REQUEST = 'COMMUNITY_UPDATE_REQUEST';
export const COMMUNITY_UPDATE_RESULT = 'COMMUNITY_UPDATE_RESULT';
export const COMMUNITY_UPDATE_RESET = 'COMMUNITY_UPDATE_RESET';

export const COMMUNITY_INFO_GET = 'COMMUNITY_INFO_GET'
export const COMMUNITY_INFO_GET_RESULT = 'COMMUNITY_INFO_GET_RESULT'

export const COMMUNITY_INFO_REMOVE = 'COMMUNITY_INFO_REMOVE'
export const COMMUNITY_CREATED_FLAG_REMOVE = 'COMMUNITY_CREATED_FLAG_REMOVE'

export const COMMUNITY_DESTROY = 'COMMUNITY_DESTROY'
export const COMMUNITY_DESTROY_RESULT = 'COMMUNITY_DESTROY_RESULT'
export const COMMUNITY_DESTROY_FLAG_REMOVE = 'COMMUNITY_DESTROY_FLAG_REMOVE'
export const COMMUNITY_PREVIEW_BACK = 'COMMUNITY_PREVIEW_BACK'
export const COMMUNITY_PREVIEW_SET = 'COMMUNITY_PREVIEW_SET'
export const COMMUNITY_PREVIEW_SET_RESULT = 'COMMUNITY_PREVIEW_SET_RESULT'
export const COMMUNITY_PREVIEW_DELETE = 'COMMUNITY_PREVIEW_DELETE'

export const COMMUNITY_PUBLISH = 'COMMUNITY_PUBLISH'
export const COMMUNITY_PUBLISH_RESULT = 'COMMUNITY_PUBLISH_RESULT'

export const COMMUNITY_JOIN = 'COMMUNITY_JOIN'
export const COMMUNITY_JOIN_RESULT = 'COMMUNITY_JOIN_RESULT'
export const COMMUNITY_JOIN_RESET = 'COMUNITY_JOIN_RESET'
export const COMMUNITY_USER_BLOCK = 'COMMUNITY_USER_BLOCK'

export const COMMUNITY_GET_APPLIED = 'COMMUNITY_GET_APPLIED'
export const COMMUNITY_GET_APPLIED_RESET = 'COMMUNITY_GET_APPLIED_RESET'
export const COMMUNITY_USER_APPROVE = 'COMMUNITY_USER_APPROVE'
export const COMMUNITY_USER_DEFECT = 'COMMUNITY_USER_DEFECT'

export const COMMUNITY_ALL_RESET = 'COMMUNITY_ALL_RESET'


// WEBPACK FOOTER //
// ./src/constants/Community.js